import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';
import './App.scss';
import useCreateLink from 'hooks/useCreateLink';
import { Navigate, useLocation } from 'react-router-dom';

const LanguageRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const savedLanguage = localStorage.getItem('language') || 'en';

  const pathSegments = location.pathname.split('/');
  const currentLanguage = pathSegments[1];
  const supportedLanguages = ['en', 'km'];

  if (location.pathname === '/reset-password') {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token') || '';
    const email = searchParams.get('email') || '';
    const newPath = `/${savedLanguage}/reset-password`;

    return <Navigate to={`${newPath}?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`} replace />;
  }

  if (!supportedLanguages.includes(currentLanguage)) {
    return <Navigate to={`/${savedLanguage}${location.pathname}`} replace />;
  }

  return <>{children}</>;
};

function App() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(savedLanguage);
  }, [i18n]);

  useEffect(() => {
    const body = document.body;

    body.classList.remove('lang-khmer');

    if (currentLang === 'km') {
      body.classList.add('lang-khmer');
    }
  }, [currentLang]);

  useCreateLink();

  return (
    <div className="App">
      <LanguageRedirect>
        <Outlet />
      </LanguageRedirect>
    </div>
  );
}

export default App;
